import React from 'react';
import { AlertCircle, CheckCircle, Info, X, AlertTriangle } from 'lucide-react';
import {
  Alert as BaseAlert,
  AlertDescription,
} from './alert-variants';
import { cn } from '../../lib/utils';

interface AlertProps {
  type: 'success' | 'error' | 'warning' | 'info';
  message: string;
  onClose?: () => void;
  className?: string;
}

const iconMap = {
  success: CheckCircle,
  error: AlertCircle,
  warning: AlertTriangle,
  info: Info,
};

const focusRingMap = {
  success: 'focus:ring-green-500',
  error: 'focus:ring-red-500',
  warning: 'focus:ring-yellow-500',
  info: 'focus:ring-blue-500',
};

const Alert: React.FC<AlertProps> = ({
  type,
  message,
  onClose,
  className = '',
}) => {
  const Icon = iconMap[type];

  return (
    <BaseAlert
      variant={type}
      className={cn('mb-4 flex items-start animate-fade-in', className)}
    >
      <div className="flex-shrink-0">
        <Icon className="h-5 w-5" aria-hidden="true" />
      </div>
      <AlertDescription className="ml-3 flex-1">
        <p className="text-sm">{message}</p>
      </AlertDescription>
      {onClose && (
        <div className="ml-auto pl-3">
          <div className="-mx-1.5 -my-1.5">
            <button
              type="button"
              onClick={onClose}
              className={`inline-flex rounded-md p-1.5 focus:outline-none focus:ring-2 focus:ring-offset-2 ${focusRingMap[type]}`}
            >
              <span className="sr-only">Dismiss</span>
              <X className="h-5 w-5" aria-hidden="true" />
            </button>
          </div>
        </div>
      )}
    </BaseAlert>
  );
};

export default Alert;
